module.exports = "/_next/static/images/62a5deb10c19e2d18201924850375bea-man-looking-up-smiling-xs@1x.jpg";